<template>
  <ProductDetailPageBase>
    <ProductDetailPageLayout>
      <template #header>
        <ContainerSkinnyBanner />
      </template>
      <template #breadcrumb>
        <ContainerBreadcrumb />
      </template>
      <template #out-of-stock>
        <ContainerOutOfStock />
      </template>
      <template #product-visuals>
        <ContainerGalleryNew />
      </template>
      <template #product-aside-content>
        <ColumnsReversedOnDesktop class="mb-16">
          <ContainerProductSummaryDesktop />
          <ContainerProductSummaryMobile />
          <ContainerFlashSalesSticker />
        </ColumnsReversedOnDesktop>
        <ContainerAdvertisedPayment />
        <ContainerReassuranceItems />
        <ContainerVerifiedRefurbishedCarousel />
        <ContainerSellerComment />
        <ContainerSeller />
      </template>
      <template #full-width-pre-content>
        <ContainerCheckpointsCarousel />
      </template>
      <template #content>
        CustomizationFunnel <br />
        <ContainerRecommendations />
        <ContainerCmsSection :index="1" />
        <ContainerReviews />
        <ContainerCmsSection :index="2" />
        <ContainerSeoLinks />
        <ContainerCmsSection :index="3" />
        <ContainerCmsSection :index="4" />
        <ContainerSeoTechSpecs />
        <ContainerCmsSection :index="5" />
        <ContainerArticles />
        <AboutUs />
        <ContainerTrustList />
      </template>
      <template #modals>
        <ContainerSwapModals />
        <ContainerVisibleByVerizonDrawer />
        <ContainerAddToCartOverlay />
        <ContainerStickyBarBottom />
        <ContainerFlashSalesModal />
      </template>
    </ProductDetailPageLayout>
  </ProductDetailPageBase>
</template>

<script setup lang="ts">
import ProductDetailPageBase from '~/scopes/product-core/components/ProductDetailPageBase/ProductDetailPageBase.vue'
import ProductDetailPageLayout from '~/scopes/product-core/components/ProductDetailPageLayout/ProductDetailPageLayout.vue'
import ContainerAddToCartOverlay from '~/scopes/product-core/components/containers/ContainerAddToCartOverlay/ContainerAddToCartOverlay.vue'
import ContainerAdvertisedPayment from '~/scopes/product-core/components/containers/ContainerAdvertisedPayment/ContainerAdvertisedPayment.vue'
import ContainerArticles from '~/scopes/product-core/components/containers/ContainerArticles/ContainerArticles.vue'
import ContainerBreadcrumb from '~/scopes/product-core/components/containers/ContainerBreadcrumb/ContainerBreadcrumb.vue'
import ContainerCheckpointsCarousel from '~/scopes/product-core/components/containers/ContainerCheckpointsCarousel/ContainerCheckpointsCarousel.vue'
import ContainerCmsSection from '~/scopes/product-core/components/containers/ContainerCmsSection/ContainerCmsSection.vue'
import ContainerFlashSalesModal from '~/scopes/product-core/components/containers/ContainerFlashSalesModal/ContainerFlashSalesModal.vue'
import ContainerFlashSalesSticker from '~/scopes/product-core/components/containers/ContainerFlashSalesSticker/ContainerFlashSalesSticker.vue'
import ContainerGalleryNew from '~/scopes/product-core/components/containers/ContainerGalleryNew/ContainerGalleryNew.vue'
import ContainerOutOfStock from '~/scopes/product-core/components/containers/ContainerOutOfStock/ContainerOutOfStock.vue'
import ContainerProductSummaryDesktop from '~/scopes/product-core/components/containers/ContainerProductSummary/ContainerProductSummaryDesktop/ContainerProductSummaryDesktop.vue'
import ContainerProductSummaryMobile from '~/scopes/product-core/components/containers/ContainerProductSummary/ContainerProductSummaryMobile/ContainerProductSummaryMobile.vue'
import ContainerReassuranceItems from '~/scopes/product-core/components/containers/ContainerReassuranceItems/ContainerReassuranceItems.vue'
import ContainerRecommendations from '~/scopes/product-core/components/containers/ContainerRecommendations/ContainerRecommendations.vue'
import ContainerReviews from '~/scopes/product-core/components/containers/ContainerReviews/ContainerReviews.vue'
import ContainerSeller from '~/scopes/product-core/components/containers/ContainerSeller/ContainerSeller.vue'
import ContainerSellerComment from '~/scopes/product-core/components/containers/ContainerSellerComment/ContainerSellerComment.vue'
import ContainerSeoLinks from '~/scopes/product-core/components/containers/ContainerSeoLinks/ContainerSeoLinks.vue'
import ContainerSeoTechSpecs from '~/scopes/product-core/components/containers/ContainerSeoTechSpecs/ContainerSeoTechSpecs.vue'
import ContainerSkinnyBanner from '~/scopes/product-core/components/containers/ContainerSkinnyBanner/ContainerSkinnyBanner.vue'
import ContainerStickyBarBottom from '~/scopes/product-core/components/containers/ContainerStickyBarBottom/ContainerStickyBarBottom.vue'
import ContainerSwapModals from '~/scopes/product-core/components/containers/ContainerSwapModals/ContainerSwapModals.vue'
import ContainerTrustList from '~/scopes/product-core/components/containers/ContainerTrustList/ContainerTrustList.vue'
import ContainerVerifiedRefurbishedCarousel from '~/scopes/product-core/components/containers/ContainerVerifiedRefurbishedCarousel/ContainerVerifiedRefurbishedCarousel.vue'
import ContainerVisibleByVerizonDrawer from '~/scopes/product-core/components/containers/ContainerVisibleByVerizonDrawer/ContainerVisibleByVerizonDrawer.vue'
import AboutUs from '~/scopes/product-core/components/presentationals/AboutUs/AboutUs.vue'
import ColumnsReversedOnDesktop from '~/scopes/product-core/components/presentationals/ColumnsReversedOnDesktop/ColumnsReversedOnDesktop.vue'
</script>
